<template>
  <div class="Block-Hint-Add-Ticker">
    <InfoIcon class="Block-Hint-Add-Ticker__icon" />Чтобы добавить тикер, используйте формат текста &nbsp;
    <span class="Block-Hint-Add-Ticker__coin">$BTC</span>, 
    <span class="Block-Hint-Add-Ticker__coin">$ETH</span>, 
    <span class="Block-Hint-Add-Ticker__coin">$USD</span>
  </div>
</template>

<script setup>
  import InfoIcon from '@svg/InfoIcon.vue';
</script>

<style lang="scss">
  @import "./styles/styles";
</style>